import i18n from "core/i18n";

const NoConfigsData = ({children, items}) => {
    const translations = {
        es: {
            noData: "No existen configuraciones para los modelos del panel.",
        },
        en: {
            noData: "There are no configurations for the panel models.",
        }
    }
    // -
    return items.length === 0
        ? <div className="alert alert-secondary text-center">{translations[i18n.language].noData}</div>
        : children;
}
export default NoConfigsData;